import {YES_NO_CHOICE_OPTIONS} from "@constants/dropdown-choices";
import ScrollableButtonGroupBlock from "@components/common/form-blocks/scrollable/button-group-block";
import ScrollableTextBoxBlock from "@components/common/form-blocks/scrollable/text-box-block";

export default function DrivingLicenseNumber({data, handlers}) {

    return (

        <div className="row hidden-box">

            {/* Would you like to enter your driving licence number? */}

            <ScrollableButtonGroupBlock
                containerCssClass="col-12 py-3 "
                labelText="Would you like to enter your driving licence number?"
                required={true}
                controlName="provideDrivingLicenseNumber"
                options={YES_NO_CHOICE_OPTIONS}
                selectedValues={data.provideDrivingLicenseNumber}
                onChange={handlers.onControlChange}
                helpText="This may reduce your premium"
            />

            {data.provideDrivingLicenseNumber === 'Yes' && (

                <ScrollableTextBoxBlock
                    containerCssClass="col-12 py-3 "
                    labelText="Please enter your 16-character GB driving licence number"
                    required={data.provideDrivingLicenseNumber === 'Yes'}
                    controlName="britishDrivingLicenseNumber"
                    value={data.britishDrivingLicenseNumber}
                    onChange={handlers.onControlChange}
                    inputAttrs={{
                        maxLength: 50
                    }}
                />

            )}

        </div>
    );

}